import { Expose } from "class-transformer";

export class UpdatePayrollLineDto {
  @Expose()
  quantity?: number;

  @Expose()
  unitPrice?: number;

  @Expose()
  amount?: number;
}
